import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export function Header() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <header style={{
      background: 'var(--nav-bg, #2d3a44)',
      borderBottom: '1px solid rgba(255,255,255,0.08)',
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
      paddingTop: 'calc(env(safe-area-inset-top, 0px) + 10px)',
      paddingBottom: '10px',
      paddingLeft: '16px',
      paddingRight: '16px',
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    }}>
      <div
        className="header-title"
        onClick={() => navigate('/')}
        style={{ cursor: 'pointer', fontSize: 18 }}
      >
        <span style={{ color: 'var(--nav-text, #eef2f5)', fontWeight: 900, letterSpacing: 2, fontSize: 20 }}>WILCO</span><span style={{ color: '#22c55e', fontWeight: 900, letterSpacing: 2, fontSize: 20 }}> 2.0</span>
      </div>

      {/* Cog → profile / settings */}
      <button
        onClick={() => navigate(user ? '/profile' : '/login')}
        aria-label="Settings"
        style={{
          width: 34, height: 34, borderRadius: 9,
          background: user ? 'rgba(16,185,129,0.08)' : 'var(--bg-input)',
          border: user ? '1px solid rgba(16,185,129,0.25)' : '1px solid var(--border)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          cursor: 'pointer', flexShrink: 0,
        }}
      >
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none"
          stroke={user ? '#10b981' : 'var(--text-muted)'} strokeWidth="1.8"
          strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3"/>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
      </button>
    </header>
  );
}
